// src/services/trialDeploymentsApi.js
import apiService from './apiService';

const trialDeploymentsApi = {
  list: (params = {}) => apiService.get('/trial-deployments', { params }),
  create: (data) => apiService.post('/trial-deployments', data),
  update: (id, data) => apiService.put(`/trial-deployments/${id}`, data),
  remove: (id) => apiService.delete(`/trial-deployments/${id}`),
};

export default trialDeploymentsApi;
